import * as t from 'io-ts';

export const SampleHarvestTypeSchema = t.keyof({
    DAIRY: null,
    VETERINARY: null,
    PRIMARY_PRODUCER: null,
});

export type SampleHarvestType = t.TypeOf<typeof SampleHarvestTypeSchema>;
